import { Button } from 'components'
import React from 'react'
import {
  setConsoleOpen,
  setSelectedConsoleTab,
  useAlgoEditorState,
  useAppDispatch
} from 'state'

import { XIcon } from '@heroicons/react/solid'
import { tx } from '@twind/core'

import { FinalCodeResult } from '../AlgoEditor.types'

import CustomTestCaseTab from './tabs/CustomTestCaseTab'
import NextQuestionTab from './tabs/NextQuestionTab'
import ResultTab from './tabs/ResultTab'

const tabs = [
  { key: 'submission_status', label: 'Submission status' },
  { key: 'custom_tests', label: 'Custom test case' },
  { key: 'next_question', label: 'Next question' }
] as const

const ConsoleSection = ({
  handleRunCode,
  submitTestCaseLoading,
  submitCodeLoading,
  finalSubmissionResponse
}: {
  handleRunCode: (_: boolean) => void
  submitTestCaseLoading: boolean
  submitCodeLoading: boolean
  finalSubmissionResponse: FinalCodeResult | undefined
}) => {
  const { consoleOpen, selectedConsoleTab, isNextChallenge } =
    useAlgoEditorState()
  const dispatch = useAppDispatch()

  const resultLoading = submitTestCaseLoading || submitCodeLoading

  return (
    <div className="text-white flex flex-col justify-center bottom-0 bg-zinc-900 border-b border-zinc-800 w-full">
      {consoleOpen ? (
        <>
          <div className="flex flex-row justify-between items-center my-1 px-6 py-2">
            <div className="space-x-2">
              {tabs.map((tab) => {
                const isSelected = tab.key === selectedConsoleTab
                if (!isNextChallenge && tab.key === 'next_question') {
                  return false
                } else {
                  return (
                    <Button
                      key={tab.key}
                      variant="transparent"
                      className={tx(
                        'text-sm py-1.5 px-2',
                        isSelected ? 'bg-white bg-opacity-10' : ''
                      )}
                      onClick={() => dispatch(setSelectedConsoleTab(tab.key))}>
                      {tab.label}
                    </Button>
                  )
                }
              })}
            </div>

            <Button
              variant="transparent"
              className="p-0"
              onClick={() => {
                if (selectedConsoleTab === 'next_question') {
                  dispatch(setSelectedConsoleTab('submission_status'))
                }
                dispatch(setConsoleOpen(false))
              }}>
              <XIcon className="h-7 w-7" />
            </Button>
          </div>

          <div className="h-[20vh] min-h-[200px] mx-5 overflow-auto">
            {selectedConsoleTab === 'custom_tests' && (
              <CustomTestCaseTab handleRunCode={handleRunCode} />
            )}
            {selectedConsoleTab === 'submission_status' && (
              <ResultTab
                loading={resultLoading}
                finalSubmissionResponse={finalSubmissionResponse}
              />
            )}
            {isNextChallenge && selectedConsoleTab === 'next_question' && (
              <NextQuestionTab
                finalSubmissionResponse={finalSubmissionResponse}
              />
            )}
          </div>
        </>
      ) : (
        <div className="flex">
          <div
            className="text-zinc-500 cursor-pointer px-3 py-1 hover:bg-white hover:bg-opacity-10"
            onClick={() => dispatch(setConsoleOpen(true))}>
            Console &uarr;
          </div>

          {finalSubmissionResponse && (
            <div className="capitalize mx-5 ml-auto">
              <span>Submission Status: </span>
              <span
                className={tx(
                  finalSubmissionResponse.status === 'Accepted'
                    ? 'text-green-500'
                    : finalSubmissionResponse.status === 'Pending'
                    ? 'text-yellow-500'
                    : 'text-red-500'
                )}>
                {finalSubmissionResponse.status}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ConsoleSection
